<script setup lang="ts">
import type { BrokerAvatarInfoProps } from '.';

import { BrokerAvatar } from '@/components/BrokerAvatar';
import { cn } from '@/utils';

const props = withDefaults(defineProps<BrokerAvatarInfoProps>(), {
	showCompanyAvatar: true,
	brokerSrc: '',
	companySrc: '',
	brokerName: '',
	companyName: ''
});
</script>

<template>
	<div :class="cn('flex flex-row items-center', props.class)">
		<!-- BrokerAvatar handles fallback images internally -->
		<BrokerAvatar
			:class="props.avatarClass"
			:avatar-shape="avatarShape"
			:company-avatar-shape="companyAvatarShape"
			:border="border"
			:sizes="sizes"
			:is-grayscale="isGrayscale"
			:show-company-avatar="showCompanyAvatar"
			:broker-src="brokerSrc"
			:company-src="companySrc"
			:broker-name="brokerName"
			:company-name="companyName"
		/>

		<div
			v-if="!hideInfo"
			:class="
				cn(
					'xl:max-w-fill-available flex w-auto max-w-[100%] flex-col',
					props.infoClasses?.wrapper
				)
			"
		>
			<p
				:class="
					cn(
						'w-auto truncate text-nowrap leading-[20px]',
						props.infoClasses?.brokerName
					)
				"
			>
				<slot name="broker"></slot>
			</p>
			<small
				:class="
					cn(
						'w-auto truncate text-nowrap leading-[18px]',
						props.infoClasses?.companyName
					)
				"
			>
				<slot name="company"></slot>
			</small>
		</div>

		<slot></slot>
	</div>
</template>
